export enum ELocalisationRejet {
    SASPerso = 1,
    SASMateriel = 2,
    Douche = 3
}